import {
  FIELD_CONFIG,
  type LayoutField,
} from "@/components/features/matter/file-repo/signature-requests/SignatureRequestPdfLayoutEditor.constants";

export function getReusableLabel(field: LayoutField) {
  if (field.type !== "text" && field.type !== "date") return "";

  const label = field.label.trim().replace(/\s+/g, " ").toLowerCase();
  if (
    !label ||
    label === "field name" ||
    label === FIELD_CONFIG[field.type].label.toLowerCase()
  ) {
    return "";
  }

  return label;
}

export function updateReusableSignerFieldValues(
  fields: LayoutField[],
  fieldValues: Record<string, string>,
  target: LayoutField,
  value: string,
) {
  const label = getReusableLabel(target);
  const updated = { ...fieldValues };
  for (const field of fields) {
    if (
      field.id === target.id ||
      (label &&
        field.signerId === target.signerId &&
        field.type === target.type &&
        getReusableLabel(field) === label)
    ) {
      updated[field.id] = value;
    }
  }
  return updated;
}

export function getReusableSignerFieldValue(
  fields: LayoutField[],
  fieldValues: Record<string, string>,
  target: LayoutField,
) {
  const targetLabel = getReusableLabel(target);
  if (!targetLabel) return "";

  const matchingField = fields.find(
    (field) =>
      field.id !== target.id &&
      field.signerId === target.signerId &&
      field.type === target.type &&
      getReusableLabel(field) === targetLabel &&
      Boolean(fieldValues[field.id] && fieldValues[field.id].trim()),
  );

  return matchingField ? fieldValues[matchingField.id].trim() : "";
}
